import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "reactstrap";

import { MyDraggable as Draggable } from "../components/Core";
import HoverBar from "../components/HoverBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import state from "../state";

import Icon from "../components/Icons";

// ES module

import ReactQuill, { Quill } from "react-quill"; // ES6
import "react-quill/dist/quill.bubble.css"; // ES6
import { generateStyle, l, setOverLay } from "../functions";

import { connect } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  content: (props) => {
    return {
      "&.ql-editor > *": props,
      "& .ql-bubble .ql-editor > *": props,
    };
  },
}));

const mapStateToProps = (state) => {
  return {
    currentLang: state.rootReducer.currentLang || 1,
    elementToEdit: state.rootReducer.elementToEdit || null,
    settings: state.rootReducer?.appearanceSettings || {},
  };
};

function TheEditor({ style, preview, onChange, value, id }) {
  const formats = [
    "header",
    "size",
    "align",
    "bold",
    "italic",
    "underline",
    "strike",
    "link",
    "color",
    "background",
    "font",
  ];

  const classes = useStyles(style);

  const colorList = [
    "#fafafa",
    "#e0e0e0",
    "#bdbdbd",
    "#757575",
    "#616161",
    "#424242",
    "#212121",
    "#ffebee",
    "#f3e5f5",
    "#e8eaf6",
    "#e1f5fe",
    "#e8f5e9",
    "#fffde7",
    "#fbe9e7",
    "#ef9a9a",
    "#ce93d8",
    "#9fa8da",
    "#81d4fa",
    "#a5d6a7",
    "#fff59d",
    "#ffcc80",
    "#ef5350",
    "#ab47bc",
    "#5c6bc0",
    "#29b6f6",
    "#66bb6a",
    "#ffee58",
    "#ffa726",
    "#e53935",
    "#8e24aa",
    "#3949ab",
    "#039be5",
    "#43a047",
    "#fdd835",
    "#fb8c00",
    "#c62828",
    "#6a1b9a",
    "#283593",
    "#0277bd",
    "#2e7d32",
    "#f9a825",
    "#ef6c00",
    "#ff1744",
    "#d500f9",
    "#3d5afe",
    "#00b0ff",
    "#00e676",
    "#ffea00",
    "#ff9100",
    "#ff8a80",
    "#ea80fc",
    "#8c9eff",
    "#80d8ff",
    "#b9f6ca",
    "#ffff8d",
    "#ffd180",
  ];

  if (
    document.querySelector(
      "#" + id + " .ql-bubble .ql-tooltip-editor input[data-link]"
    )
  )
    document.querySelector(
      "#" + id + " .ql-bubble .ql-tooltip-editor input[data-link]"
    ).placeholder = l("Secured url is recommended");

  if (preview)
    return (
      <div
        className={`element-container ql-editor ${classes.content}`}
        dangerouslySetInnerHTML={{ __html: value }}
      ></div>
    );
  else {
    return (
      <div className={classes.content}>
        <ReactQuill
          value={value}
          onChange={onChange}
          modules={{
            toolbar: [
              ["bold", "italic", "underline", "strike"],
              ["link"],
              [
                {
                  size: [
                    "9px",
                    "10px",
                    "12px",
                    "14px",
                    "16px",
                    "18px",
                    "20px",
                    "22px",
                    "26px",
                    "32px",
                    "36px",
                    "40px",
                    "56px",
                    "72px",
                  ],
                },
              ],
              [{ color: colorList }, { background: colorList }],
              ["clean"],
            ],
          }}
          preserveWhitespace={true}
          formats={formats}
          theme="bubble"
        />
      </div>
    );
  }
}

class Heading extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      payload: this.props.payload,
      content: null,
      showEditor: false,
    };
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { id, dropzoneID, parentID } = this.props;

    if (
      prevState.content !== this.state.content &&
      this.state.content !== null
    ) {
      clearTimeout(this.changeValues);
      this.changeValues = setTimeout(() => {
        const { payload } = this.props;

        if (payload === null) payload = this.props.options.payload;

        this.setState(
          {
            payload: {
              ...payload,
              content: this.state.content,
            },
          },
          () => {
            state.updateElement(id, dropzoneID, parentID, {
              payload: this.state.payload,
            });
          }
        );
      }, 500);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      JSON.stringify(nextProps.payload) !== JSON.stringify(this.state.payload)
    )
      this.setState({ payload: nextProps.payload });
  }

  _generateTags = (preview) => {
    let { id, name, subName } = this.props;
    let { payload } = this.state;

    if (payload === null) payload = this.props.options.payload;

    const settings =
      (this.props.settings &&
        (this.props.settings[name] || this.props.settings["body"])) ||
      {};

    const cssSettings = generateStyle(payload, "container");
    const cssSettingsText = {
      ...generateStyle(payload, "text", name),
    };
    if (name == "Paragraph" && !cssSettingsText?.fontSize) {
      cssSettingsText.fontSize = settings?.size;
    }

    const defaultText = payload.dummyContent || "Lorem Ipsum Dolor Sit Amets";
    const currentText =
      (this.state.content && this.state.content[this.props.currentLang]) ||
      (payload.content && payload.content[this.props.currentLang]) ||
      defaultText;

    // console.log(currentText);
    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className="fullcol">
            <div className="text-element">
              <TheEditor
                id={id}
                style={cssSettingsText}
                onChange={this._changedContent}
                value={currentText}
                preview={
                  preview ||
                  !(
                    this.props.elementToEdit &&
                    this.props.elementToEdit.id === id
                  )
                }
              />
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  _changedContent = (text) => {
    this.setState({
      ...this.state,
      content: {
        ...this.state.content,
        [this.props.currentLang]: text,
      },
    });
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.subName || rest.name)}</span>
          </span>
        </Draggable>
      );
    }

    if (showPreview) return this._generateTags(true);

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._generateTags(false)}
      </Draggable>
    );
  }
}

// Add sizes to whitelist and register them
const Size = Quill.import("attributors/style/size");
Size.whitelist = [
  "9px",
  "10px",
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "22px",
  "26px",
  "32px",
  "36px",
  "40px",
  "56px",
  "72px",
];
Quill.register(Size, true);

Heading.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(Heading);
